module.exports = __webpack_public_path__ + "media/promo/courses/images/pepper2-42a9bc6962bfe078dfb41283559541e9.png";